(() => {
  'use strict';

  const module = angular.module('uwAgenda.settings.agendasettings');

  module.controller('IntegrationsOverviewController', [
    '$rootScope',
    '$uibModal',
    'SharedAgendaService',
    'IntegrationService',
    'IntegratorTypeEnum',
    'HelperService',
    'Alert',
    '$translate',
    'AppConfig',
    IntegrationsOverviewControllerFn
  ]);

  function IntegrationsOverviewControllerFn(
    $rootScope,
    $uibModal,
    SharedAgendaService,
    IntegrationService,
    IntegratorTypeEnum,
    HelperService,
    Alert,
    $translate,
    AppConfig) {
    const vm = this;

    activate();

    function activate() {
      const currentUser = SharedAgendaService.currentUser();
      IntegrationService
        .getIntegrationsByUserId(currentUser.id)
        .then(onLoadedIntegrations);
      
      IntegrationService
        .getIntegrationsSharedWithUser(currentUser.id)
        .then(onLoadedSharedIntegrations);

      vm.copyLink = () => {
        HelperService.copyTextToClipboard(vm.url);
        const confirmation = $translate.instant('value_copied', {value: vm.url});
        Alert.info(confirmation);
      };
    }

    function onLoadedIntegrations(integrations) {
      clearIntegrations();
      mapIntegrations(integrations);
      registerButtonHandlers();
      registerModals();

      vm.url = '';
      if (vm.googleIntegration) {
        vm.url = AppConfig.ApiUrl + '/api/integrations/' + vm.googleIntegration.id + '/ical/' + vm.googleIntegration.key;
      }
    }
    
    function onLoadedSharedIntegrations(integrations) {
      clearSharedIntegrations();
      mapSharedIntegrations(integrations);
    }

    function clearIntegrations() {
      vm.eyeFileIntegration = undefined;
      vm.careConnectIntegration = undefined;
      vm.googleIntegration = undefined;

      vm.url = '';
    }
    
    function clearSharedIntegrations() {
      vm.sharedEyeFileIntegrations = [];
      vm.sharedCareConnectIntegrations = [];
    }
    
    function isInSharedIntegration() {
      return (vm.sharedEyeFileIntegrations && vm.sharedEyeFileIntegrations.length > 0) ||
        (vm.sharedCareConnectIntegrations && vm.sharedCareConnectIntegrations.length > 0);
    }

    function mapIntegrations(integrations) {
      for (let i = 0; i < integrations.length; i++) {
        const integration = integrations[i];
        if (integration.type === IntegratorTypeEnum.Eyefile.value) {
          vm.eyeFileIntegration = integration;
        } else if (integration.type === IntegratorTypeEnum.CareconnectGp.value) {
          vm.careConnectIntegration = integration;
        } else if (integration.type === IntegratorTypeEnum.GoogleCalendar.value) {
          vm.googleIntegration = integration;
        }
      }
    }
    
    function mapSharedIntegrations(integrations) {
      for (let i = 0; i < integrations.length; i++) {
        const integration = integrations[i];
        if (integration.type === IntegratorTypeEnum.Eyefile.value) {
          vm.sharedEyeFileIntegrations.push(integration);
        } else if (integration.type === IntegratorTypeEnum.CareconnectGp.value) {
          vm.sharedCareConnectIntegrations.push(integration);
        }
      }
    }

    function registerButtonHandlers() {
      vm.activateGoogleIntegration = () => activateIntegration(IntegratorTypeEnum.GoogleCalendar.value);
      vm.activateEyeFileIntegration = () => warnAndActivateIntegration(IntegratorTypeEnum.Eyefile.value);
      vm.activateCareConnectIntegration = () => warnAndActivateIntegration(IntegratorTypeEnum.CareconnectGp.value);

      vm.regenerateGoogleKey = () => regenerateKey(vm.googleIntegration.id);

      vm.regenerateCareConnectKey = () => {
        showRegenerateKeyWarningModal()
            .then(() => regenerateKey(vm.careConnectIntegration.id))
      };
      vm.regenerateEyeFileKey = () => {
        showRegenerateKeyWarningModal()
            .then(() => regenerateKey(vm.eyeFileIntegration.id))
      };
      
      vm.deactivateGoogleIntegration = () => deactivateIntegration(vm.googleIntegration.id);
      vm.deactivateEyeFileIntegration = () => deactivateIntegration(vm.eyeFileIntegration.id);
      vm.deactivateCareConnectIntegration = () => deactivateIntegration(vm.careConnectIntegration.id);

      vm.toggleAutoDeactivateContactsEyeFileIntegration = () => {
        vm.eyeFileIntegration.autoDeactivateContacts = !vm.eyeFileIntegration.autoDeactivateContacts;
        updateAutoDeactivateContacts(vm.eyeFileIntegration.id, vm.eyeFileIntegration.autoDeactivateContacts)
      };
      vm.toggleAutoDeactivateContactsCareConnectIntegration = () => {
        vm.careConnectIntegration.autoDeactivateContacts = !vm.careConnectIntegration.autoDeactivateContacts;
        updateAutoDeactivateContacts(vm.careConnectIntegration.id, vm.careConnectIntegration.autoDeactivateContacts)
      };
    }
    
    function warnAndActivateIntegration(type) {
      if (isInSharedIntegration()) {
        showAlreadyInAnIntegrationModal().then(() => activateIntegration(type));
      } else {
        activateIntegration(type);
      }
    }

    function activateIntegration(type) {
      const currentUser = SharedAgendaService.currentUser();
      return IntegrationService
        .activateIntegration(currentUser.id, type, false)
        .then(activateResult => {
          return IntegrationService
            .getIntegrationsByUserId(currentUser.id)
            .then(onLoadedIntegrations);
        });
    }

    function deactivateIntegration(id) {
      const currentUser = SharedAgendaService.currentUser();
      return IntegrationService
        .deactivateIntegration(id)
        .then(deactivateResult => {
          return IntegrationService
            .getIntegrationsByUserId(currentUser.id)
            .then(onLoadedIntegrations);
        });
    }

    function regenerateKey(id) {
      const currentUser = SharedAgendaService.currentUser();
      return IntegrationService
        .updateIntegrationKey(id, false)
        .then(updateKeyResult => {
          return IntegrationService
            .getIntegrationsByUserId(currentUser.id).then(onLoadedIntegrations);
        });
    }
    
    function updateAutoDeactivateContacts(id, updateAutoDeactivateContacts) {
      const currentUser = SharedAgendaService.currentUser();
      return IntegrationService
        .updateAutoDeactivateContacts(id, updateAutoDeactivateContacts)
        .then(updateAutoDeactivateContactsResult => {
          return IntegrationService
            .getIntegrationsByUserId(currentUser.id).then(onLoadedIntegrations);
        });
    }

    function registerModals() {
      vm.showEyeFileIntegrationModal = showEyeFileIntegrationModal;
      vm.showCareConnectIntegrationModal = showCareConnectIntegrationModal;
    }

    function showEyeFileIntegrationModal() {
      return $uibModal.open({
        keyboard: false,
        animation: true,
        templateUrl: '/app/settings/agendasettings/modules/integrations/templates/eyefile-integration-modal.template.html',
        controller: 'EyeFileIntegrationModalController',
        controllerAs: 'vm',
        size: 'xs',
        resolve: {
          id: () => vm.eyeFileIntegration.id,
        }
      }).result;
    }

    function showCareConnectIntegrationModal() {
      return $uibModal.open({
        keyboard: false,
        animation: true,
        templateUrl: '/app/settings/agendasettings/modules/integrations/templates/careconnect-integration-modal.template.html',
        controller: 'CareConnectIntegrationModalController',
        controllerAs: 'vm',
        size: 'xs',
        resolve: {
          id: () => vm.careConnectIntegration.id,
        }
      }).result;
    }

    function showRegenerateKeyWarningModal() {
      return $uibModal.open({
        keyboard: false,
        animation: true,
        templateUrl: '/app/settings/agendasettings/modules/integrations/templates/regenerate-key-warning-modal.html',
        controller: 'RegenerateKeyWarningModalController',
        controllerAs: 'vm',
        size: 'xs',
      }).result;
    }

    function showAlreadyInAnIntegrationModal() {
      return $uibModal.open({
        keyboard: false,
        animation: true,
        templateUrl: '/app/settings/agendasettings/modules/integrations/templates/already-in-integration-warning-modal.html',
        controller: 'AlreadyInIntegrationWarningModalController',
        controllerAs: 'vm',
        size: 'xs',
      }).result;
    }
  }
})();
